import Vue from 'vue';
import Vuex from 'vuex';

import { actions } from './actions';
import { getters } from './getters';
import Logger from './logger';
// MODULES
import { filters } from './modules/filters';
import { overviewPanel } from './modules/overview-panel';
import { mutations } from './mutations';
import { state } from './state';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
    strict: debug,
    plugins: debug ? [Logger()] : [],
    modules: {
        filters,
        overviewPanel
    },
    actions,
    getters,
    mutations,
    state
});



// WEBPACK FOOTER //
// ./src/store/index.js